export default __webpack_public_path__ + "static/media/confirmBg.28f44d2f.jpg";